export const networkList = {
  general: {
    divers: 'reserved for future use',
  },
  networks: [
    {
      1: {
        chainId: 1,
        networkName: 'Ethereum',
        symbol: 'ETH',
        currencyName: 'Ether',
        checkPxGas: true,
        scanlink: `https://etherscan.io/`,
        RPC_URL: `https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161`,
        testnet: false,
        faucet: `https://faucet.rinkeby.io/`,
        opensea: `https://opensea.io/account?tab=created`,
      },
      4: {
        chainId: 4,
        networkName: 'Rinkeby',
        symbol: 'ETH',
        currencyName: 'Ether',
        checkPxGas: false,
        scanlink: `https://rinkeby.etherscan.io/`,
        RPC_URL: `https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161`,
        testnet: true,
        faucet: `https://faucet.rinkeby.io/`,
        opensea: `https://testnets.opensea.io/account?tab=created`,
      },
      5: {
        chainId: 5,
        networkName: 'Goerli',
        symbol: 'GOR',
        currencyName: 'Ether',
        checkPxGas: false,
        scanlink: `https://goerli.etherscan.io/`,
        RPC_URL: `https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161`,
        testnet: true,
        faucet: `https://goerli.etherscan.io/`,
        opensea: `https://testnets.opensea.io/account?tab=created`,
      },
      80001: {
        chainId: 80001,
        networkName: 'Mumbai',
        symbol: 'MATIC',
        currencyName: 'MATIC',
        checkPxGas: false,
        scanlink: `https://explorer-mumbai.maticvigil.com/`,
        RPC_URL: `https://rpc-mumbai.matic.today/`,
        testnet: true,
        faucet: `https://faucet.polygon.technology/`,
        opensea: `https://testnets.opensea.io/account?tab=created`,
      },
      137: {
        chainId: 137,
        networkName: 'Polygon',
        symbol: 'MATIC',
        currencyName: 'MATIC',
        checkPxGas: true,
        scanlink: `https://explorer.matic.network/`,
        RPC_URL: `https://rpc-mainnet.maticvigil.com`,
        testnet: false,
        faucet: `https://macncheese.finance/matic-polygon-mainnet-faucet-fr.php`,
        opensea: `https://opensea.io/account?tab=created`,
      },
      69: {
        chainId: 69,
        networkName: 'Optimistic Ethereum (Kovan)',
        symbol: 'ETH',
        currencyName: 'Ether',
        checkPxGas: false,
        scanlink: `https://kovan-optimistic.etherscan.io/`,
        RPC_URL: `https://kovan.optimism.io/`,
        testnet: true,
        faucet: `https://gitter.im/kovan-testnet/faucet`,
        opensea: `https://testnets.opensea.io/account?tab=created`,
      },
    }
  ],
};
